import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { eventPlatformApi, type RegistryEntry } from '../../api/eventplatform';

export function SchemaRegistryPage() {
  const [entries, setEntries] = useState<RegistryEntry[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void eventPlatformApi.registry().then((r) => setEntries(r.registry)).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/events" className="text-sm text-blue-600 hover:underline">← Event Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Schema Registry</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-3">
        {entries.map((e) => (
          <div key={e.id} className="rounded-xl border p-4 dark:border-slate-700">
            <p className="font-mono font-medium">{e.event_name}</p>
            <p className="text-sm text-slate-500">v{e.version} · {e.kind} · {e.module_id ?? 'platform'}</p>
            {e.description && <p className="mt-1 text-sm">{e.description}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
